import CheckboxInput from './components/CheckboxInput'
import PrescribeForm from './PrescribeForm'
import NewPatientForm from './NewPatientForm'
import EditPatientForm from './EditPatientForm'
import EditIDTFPatientForm from './EditIDTFPatientForm'
import EnrollmentForm from './EnrollmentForm'
import NewMemberForm from './NewMemberForm'
import EditMemberForm from './EditMemberForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import InboxSettingsForm from './InboxSettingsForm'
import PatientDetailForm from './PatientDetail'
import TeamSettingsForm from './TeamSettingsForm'

export {
  PrescribeForm,
  NewPatientForm,
  EditPatientForm,
  EditIDTFPatientForm,
  CheckboxInput,
  EnrollmentForm,
  NewMemberForm,
  EditMemberForm,
  UpdatePasswordForm,
  InboxSettingsForm,
  PatientDetailForm,
  TeamSettingsForm,
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/index.js